@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.title {
  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.8rem;
  }
}

.text {
  position: relative;
  z-index: 10;
  margin-top: 4rem;
  white-space: pre-line;
  vertical-align: bottom;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.25rem;
  text-align: left;
  color: #fff;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-top: 0.43rem;
    font-size: 1rem;
    line-height: 2rem;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

.text-with-button {
  a {
    color: #abe6df;
  }
}

.bottom-container {
  position: relative;
  z-index: 10;
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  margin-top: 7.5rem;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-top: 3rem;
  }

  &__text {
    color: #fff;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 2rem;
    margin: 0.125rem 0 1.5rem;
    white-space: pre-line;
    vertical-align: bottom;
  }
}
